import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "./scripts/UserContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { getManageAccesses } from "./scripts/API/manageAccessAPI";
import "./styles/App.css";
import "./styles/material-icons.css";
import NotFound from "./components/NotFound";
import NotAuthorized from "./components/NotAuthorized";
import Sidebar from "./scripts/Sidebar";
import MainMenu from "./scripts/MainMenu";

// *** WITH UI Styling Start ***
// User
import ManageUsersComponent from "./components/User/ManageUsers";
import CreateUserComponent from "./components/User/CreateUser";
import ManageAccess from "./scripts/Users/ManageAccess";

//Admin Hub
import DeleteTechniciansComponent from "./scripts/Admin/DeleteTechnicians";
import DeleteUsersComponent from "./scripts/Admin/DeleteUsers";

// SalesRep
import SalesRepListComponent from "./components/SalesRep/SalesRepList";
import ViewSalesRepComponent from "./components/SalesRep/ViewSalesRep";
import CreateSalesRepComponent from "./components/SalesRep/CreateSalesRep";
import UpdateSalesRepComponent from "./components/SalesRep/UpdateSalesRep";
import DeleteSalesRepComponent from "./components/SalesRep/DeleteSalesRep";
// Client
import ClientListComponent from "./components/Client/ClientList";

import JobSchedulesComponent from "./scripts/JobSchedules";
// Lead
import LeadListComponent from "./components/Leads/LeadList";

// Operations
import JobOrderListComponent from "./components/Operations/JobOrderList";
import LeadScheduleListComponent from "./components/Operations/LeadScheduleList";
// *** WITH UI Styling End ***

// *** WITHOUT UI styling start ***

// ***Sales Start
// ****Lead Subsection Start
import ManageLeads from "./scripts/Leads/ManageLeads";
import AddNewLead from "./scripts/Leads/AddNewLead";
import ViewLead from "./scripts/Leads/ViewLead";
import EditLead from "./scripts/Leads/EditLead";
// ****Lead Subsection End

// **** Contracts Subsection Start 
import ManageContracts from "./scripts/Billing/ManageContracts";
import CreateContract from "./scripts/Billing/CreateContract";
import ViewContract from "./scripts/Billing/ViewContract";
import EditContract from "./scripts/Billing/EditContract";
import DeleteContract from "./scripts/Billing/DeleteContract";

import CreateInvoice from "./scripts/Billing/CreateInvoice";
import ViewInvoice from "./scripts/Billing/ViewInvoice";
import EditInvoice from "./scripts/Billing/EditInvoice";
import DeleteInvoice from "./scripts/Billing/DeleteInvoice";
// **** Contracts Subsection End

// *** Sales Report Start
import SalesReport from "./scripts/Billing/SalesReport";
// *** Sales Report End

// *** Contracts View Start
import ContractsView from "./scripts/Billing/ContractsView";
// *** Contracts View End

// ****SalesRep Subsection Start
import ManageSalesReps from "./scripts/SalesReps/ManageSalesReps";
import AddSalesRep from "./scripts/SalesReps/AddSalesRep";
import ViewSalesRep from "./scripts/SalesReps/ViewSalesRep";
import EditSalesRep from "./scripts/SalesReps/EditSalesRep";
import DeleteSalesRep from "./scripts/SalesReps/DeleteSalesRep";
// ****SalesRep Subsection End

// ****Lead Status Subsection Start
import ViewLeadStatusReport from "./scripts/Reports/ViewLeadStatusReport";

// ****Lead Status Subsection End

// ***Sales End

// ***Operations Start
// ****Job Orders Subsection Start
import ManagePendingJobSchedule from "./scripts/JobOrders/ManagePendingJobSchedule";
import ManageJobOrders from "./scripts/JobOrders/ManageJobOrders";
import ScheduleJobOrder from "./scripts/JobOrders/ScheduleJobOrder";
import CreateJobOrder from "./scripts/JobOrders/CreateJobOrder";
import ViewJobOrder from "./scripts/JobOrders/ViewJobOrder";
import EditJobOrder from "./scripts/JobOrders/EditJobOrder";
import DeleteJobOrder from "./scripts/JobOrders/DeleteJobOrder";
// ****Job Orders Subsection End

// ****Daily Forecast Subsection Start
import ViewDailyForecast from "./scripts/DailyForecast/ViewDailyForecast";
// ****Daily Forecast Subsection End

// ****Technician Assignment Start
import AssignTechnicians from "./scripts/TechnicianAssignment/AssignTechnicians";
import BatchAssign from "./scripts/TechnicianAssignment/BatchAssign";
// ****Technician Assignment End


// ****Calendar Start
import ViewCalendar from "./scripts/Calendar/ViewCalendar";
// ****Calendar End

// ****Service Reports Start
import CreateServiceReport from "./scripts/ServiceReports/CreateServiceReport";
import SubmitServiceReport from "./scripts/ServiceReports/SubmitServiceReport";
import ManageServiceReports from "./scripts/ServiceReports/ManageServiceReports";
import ViewServiceReport from "./scripts/ServiceReports/ViewServiceReport";
import EditServiceReport from "./scripts/ServiceReports/EditServiceReport";
import MakatiGpcForm from "./scripts/ServiceReports/MakatiGpcForm";
import TransmittalForm from "./scripts/ServiceReports/TransmittalForm";
import TermiteControlForm from "./scripts/ServiceReports/TermiteControlForm";
import QcForm from "./scripts/ServiceReports/QcForm";
import ViewMakatiGpcForm from "./scripts/ServiceReports/ViewMakatiGpcForm";
import ViewTransmittalForm from "./scripts/ServiceReports/ViewTransmittalForm";
import ViewTermiteControlForm from "./scripts/ServiceReports/ViewTermiteControlForm";
import ViewQcForm from "./scripts/ServiceReports/ViewQcForm";
import EditQcForm from "./scripts/ServiceReports/EditQcForm";
import EditMakatiGpcForm from "./scripts/ServiceReports/EditMakatiGpcForm";
import EditTransmittalForm from "./scripts/ServiceReports/EditTransmittalForm";
import EditTermiteControlForm from "./scripts/ServiceReports/EditTermiteControlForm";
import DeleteMakatiGpcForm from "./scripts/ServiceReports/DeleteMakatiGpcForm";
import DeleteTransmittalForm from "./scripts/ServiceReports/DeleteTransmittalForm";
import DeleteTermiteControlForm from "./scripts/ServiceReports/DeleteTermiteControlForm";
import DeleteQcForm from "./scripts/ServiceReports/DeleteQcForm";
// ****Service Reports End

// ****Payroll Start
import PayrollReports from "./scripts/Payroll/PayrollReports";
import PayrollFinalCalculation from "./scripts/Payroll/PayrollFinalCalculation";
import TechnicianHours from "./scripts/Payroll/TechnicianHours";
import TechnicianCompensation from "./scripts/Payroll/TechnicianCompensation";
// ****Payroll End

// ****Productivity Report Start
import ViewProductivityReport from "./scripts/Reports/ViewProductivityReport";
// ****Productivity Report End

// ****Operation Completion Report Start
import ViewOperationCompletionReport from "./scripts/Reports/ViewOperationCompletionReport";
// ****Operation Completion Report End

// ****Open Job Orders Report Start
import ViewOpenJobOrdersReport from "./scripts/Reports/ViewOpenJobOrdersReport";
// ****Open Job Orders Report End

// ****Accomplishment Reports Start
import CreateAccomplishmentReport from "./scripts/AccomplishmentReports/CreateAccomplishmentReport";
// ****Accomplishment Reports End

// ****Technicians Start
import ManageTechnicians from "./scripts/Technicians/ManageTechnicians";
import AddTechnician from "./scripts/Technicians/AddTechnician";
import ViewTechnician from "./scripts/Technicians/ViewTechnician";
import EditTechnician from "./scripts/Technicians/EditTechnician";
import ViewCompetencySkillsMatrix from "./scripts/Technicians/ViewCompetencySkillsMatrix";
import ViewProfessionalSkillsMatrix from "./scripts/Technicians/ViewProfessionalSkillsMatrix";
import ViewRestDay from "./scripts/Technicians/ViewRestDay";
// ****Technicians End

// ****Route Planner Start
import RoutePlanner from "./scripts/RoutePlanner/ViewRoutes";
// ****Route Planner End

// ****Endorsement Form Start
import CreateEndorsementForm from "./scripts/EndorsementForm/CreateEndorsementForm";
import ManageEndorsementForm from "./scripts/EndorsementForm/ManageEndorsementForm";
import ViewEndorsementForm from "./scripts/EndorsementForm/ViewEndorsementForm";
import EditEndorsementForm from "./scripts/EndorsementForm/EditEndorsementForm";
import SubmitEndorsementForm from "./scripts/EndorsementForm/SubmitEndorsementForm";
// ****Endorsement Form End

// ***Operations End

// ***Finance Start
// ****Billing Records Start
import ManageBillingRecords from "./scripts/BillingRecords/ManageBillingRecords";
import CreateBillingRecord from "./scripts/BillingRecords/CreateBillingRecord";
import ViewBillingRecord from "./scripts/BillingRecords/ViewBillingRecord";
import EditBillingRecord from "./scripts/BillingRecords/EditBillingRecord";
import AddBillingRecordWorkNotes from "./scripts/BillingRecords/AddBillingRecordWorkNotes";
import ViewAgingInvoices from "./scripts/BillingRecords/ViewAgingInvoices";
// ****Billing Records End
// ***Finance End

// ***Client Retention Start
// ****Clients Start
import ManageClients from "./scripts/Clients/ManageClients";
import CreateClient from "./scripts/Clients/CreateClient";
import ViewClient from "./scripts/Clients/ViewClient";
import ClientJobOrderHistory from "./scripts/Clients/ClientJobOrderHistory";
import ViewClientServiceReports from "./scripts/Clients/ViewClientServiceReports";
import ViewClientServiceHistory from "./scripts/Clients/ViewClientServiceHistory";
import ViewClientBillingRecords from "./scripts/Clients/ViewClientBillingRecords";
import ViewClientBillingHistory from "./scripts/Clients/ViewClientBillingHistory";
import EditClient from "./scripts/Clients/EditClient";
import ListEmailExceptions from "./scripts/Clients/ListEmailExceptions";
import ManageEmailException from "./scripts/Clients/ManageEmailException";
// ****Clients End

// ****Job Order Reminder Start
// import SendJobOrderReminder from "./scripts/Clients/SendJobOrderReminder";
// ****Job Order Reminder End

// ****Billing Reminder Start
import SendBillingReminder from "./scripts/Clients/SendBillingReminder";
// ****Billing Reminder End

// ****Promotions Start
import SendPromotions from "./scripts/Promotions/SendPromotions";
// ****Promotions End
// ***Client Retention End

// ***Franchise Start
// ***Franchise End

// ***Admin Start
// ****Users Start
import ManageUsers from "./scripts/Users/ManageUsers";
import ViewUser from "./scripts/Users/ViewUser";
import AddUser from "./scripts/Users/AddUser";
import EditUser from "./scripts/Users/EditUser"; // Import the EditUser component
import DeleteUser from "./scripts/Users/DeleteUser"; // Import the EditUser component
import ChangePassword from "./scripts/Users/ChangePassword"; // Import the EditUser component
import ResetPassword from "./scripts/Users/ResetPassword"; // Import the EditUser component
import LoginUser from "./scripts/LoginUser";
import LogoutUser from "./scripts/LogoutUser";
// ****Users End
// ***Admin End

// ****** Test Components Start

import PlotSchedule from "./scripts/Scheduler/PlotSchedule";
import TestScheduler from "./scripts/Scheduler/ListLeadSchedule"; //testing scheduler - need to remove
import ListJobOrders from "./scripts/JobOrders/ManageJobOrders"; //testing job orders - need to remove
import ListLeadSchedule from "./scripts/Scheduler/ListLeadSchedule";
import JobSchedules from "./scripts/JobSchedules";
import TechnicianAssignment from "./scripts/TechnicianAssignment/AssignTechnicians"


// ****** Test Components End

// *** WITHOUT UI styling end ***
const checkAuthorization = (path) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user || !user.access) return false;

  const accessList = Object.values(user.access).flat();

  // Convert route to regex for dynamic paths
  const pathMatch = accessList.some((route) => {
    // Handle wildcard (*) explicitly
    if (route === "*") {
      return true; // Allow all paths
    }

    try {
      const routeRegex = new RegExp(
        `^${route.replace(/:[^\s/]+/g, "([^/]+)")}$`
      );
      return routeRegex.test(path);
    } catch (error) {
      console.error(`Invalid route pattern: ${route}`, error);
      return false;
    }
  });

  return pathMatch;
};

const isAuthorized = (path) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user || !user.access) return false;

  const accessEntries = Array.isArray(user.access)
    ? user.access
    : [user.access]; // Ensure it's treated as an array even if it's a single object.

  return accessEntries.some((access) => {
    return Object.values(access).some((routes) => {
      return routes.some((route) => {
        // Check for wildcard '*' or root '/'
        if (route === "*") {
          return true; // Allow all routes if wildcard is present
        }
        if (route === "/") {
          return path === "/" || path.startsWith("/");
        }

        // Escape special characters in route and replace dynamic segments
        const routeRegex = new RegExp(
          `^${route.replace(/:[^\s/]+/g, "[^/]+")}$`
        );

        return routeRegex.test(path);
      });
    });
  });
};

function ProtectedRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem("token");

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Check authorization for current route
  if (!checkAuthorization(location.pathname)) {
    return <Navigate to="/not-authorized" />;
  }

  return children;
}
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );

  // const { setUser } = useContext(UserContext); // Access the context setter

  // Function to update authentication status
  const handleLogin = async (token, userDetails, callback) => {
    localStorage.setItem("token", token);

    try {
      const result = await getManageAccesses();

      // Transform roles to { role: routes }
      const access = userDetails.roles.reduce((acc, role) => {
        const matchedRole = result.find((item) => item.role === role);
        acc[role] = matchedRole ? matchedRole.routes : [];
        return acc;
      }, {});

      // Add access to userDetails
      userDetails.access = access;
    } catch (error) {
      console.error("Failed to get manage accesses", error);
      userDetails.access = {};
    }

    localStorage.setItem("user", JSON.stringify(userDetails));
    setIsAuthenticated(true);

    if (callback) callback();
    // setUser(userDetails); // Set user details in context
  };

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  return (
    <Router>
      <div className="dashboard-container">
        {isAuthenticated && <Sidebar />}
        <main className="main-content">
          <Routes>
            {/* *** WITH UI styling start ***   */}
            <Route
              path="/manage-users"
              element={
                <ProtectedRoute>
                  <ManageUsersComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/change-password/:id"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-user"
              element={
                <ProtectedRoute>
                  <CreateUserComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manage-access"
              element={
                <ProtectedRoute>
                  <ManageAccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-technicians"
              element={
                <ProtectedRoute>
                  <DeleteTechniciansComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-users"
              element={
                <ProtectedRoute>
                  <DeleteUsersComponent />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/manage-salesreps"
              element={
                <ProtectedRoute>
                  <SalesRepListComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-salesrep"
              element={
                <ProtectedRoute>
                  <CreateSalesRepComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-salesrep"
              element={
                <ProtectedRoute>
                  <ViewSalesRepComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/update-salesrep"
              element={
                <ProtectedRoute>
                  <UpdateSalesRepComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-salesrep"
              element={
                <ProtectedRoute>
                  <DeleteSalesRepComponent />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/manage-clients"
              element={
                isAuthenticated ? <ClientListComponent /> : <Navigate to="/login" />
              }
            /> */}
            {/* <Route
              path="/job-schedules"
              element={
                isAuthenticated ? <JobSchedulesComponent /> : <Navigate to="/login" />
              }
            /> */}
            {/* <Route
              path="/manage-leads"
              element={
                isAuthenticated ? <LeadListComponent /> : <Navigate to="/login" />
              }
            /> */}
            {/* <Route
              path="/manage-job-orders"
              element={
                isAuthenticated ? <JobOrderListComponent /> : <Navigate to="/login" />
              }
            /> */}
            {/* <Route
              path="/list-lead-schedules"
              element={
                isAuthenticated ? (
                  <LeadScheduleListComponent />
                ) : (
                  <Navigate to="/login" />
                )
              }
            /> */}
            {/* *** WITH UI styling end ***   */}
            {/* *** WITHOUT UI styling start ***   */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainMenu />
                </ProtectedRoute>
              }
            />
            {/* ***Sales Section Start */}
            {/* ****Leads Subsection Start  */}
            {/* <Route
              path="/manage-leads"
              element={
                <ProtectedRoute>
                  <ManageLeads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-new-lead"
              element={
                <ProtectedRoute>
                  <AddNewLead />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-lead/:id"
              element={
                <ProtectedRoute>
                  <ViewLead />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-lead/:id"
              element={
                <ProtectedRoute>
                  <EditLead />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-lead-status-report"
              element={
                <ProtectedRoute>
                  <ViewLeadStatusReport />
                </ProtectedRoute>
              }
            /> */}
            {/* ****Leads Subsection End  */}
            {/* ****SalesRep Subsection Start  */}
            {/* <Route
              path="/manage-salesreps"
              element={
                isAuthenticated ? <ManageSalesReps /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/add-salesrep"
              element={
                isAuthenticated ? <AddSalesRep /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/view-salesrep/:id"
              element={
                isAuthenticated ? <ViewSalesRep /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/edit-salesrep/:id"
              element={
                isAuthenticated ? <EditSalesRep /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/delete-salesrep/:id"
              element={
                isAuthenticated ? <DeleteSalesRep /> : <Navigate to="/login" />
              }
            /> */}
            {/* ****Billing Subsection Start */}
            <Route
              path="/manage-contracts"
              element={
                <ProtectedRoute path="/manage-contracts">
                  <ManageContracts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-contract"
              element={
                <ProtectedRoute>
                  <CreateContract />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-contract/:contract_id"
              element={
                <ProtectedRoute>
                  <ViewContract />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-contract/:contract_id"
              element={
                <ProtectedRoute>
                  <EditContract />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-contract/:contract_id"
              element={
                <ProtectedRoute>
                  <DeleteContract />
                </ProtectedRoute>
              }
            />

            <Route
              path="/create-invoice"
              element={
                <ProtectedRoute>
                  <CreateInvoice />
                </ProtectedRoute>
              }
            />

            <Route
              path="/view-invoice"
              element={
                <ProtectedRoute>
                  <ViewInvoice />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-invoice"
              element={
                <ProtectedRoute>
                  <EditInvoice />
                </ProtectedRoute>
              }
            />

            <Route
              path="/delete-invoice"
              element={
                <ProtectedRoute>
                  <DeleteInvoice />
                </ProtectedRoute>
              }
            />

            <Route 
              path="/contracts-view"
              element={
                <ProtectedRoute>
                  <ContractsView />
                </ProtectedRoute>
              }
            />

            <Route
              path="/sales-report"
              element={
                <ProtectedRoute>
                  <SalesReport />
                </ProtectedRoute>
              }
            />
            {/* ****Billing Subsection End */}

            {/* **** Sales Report Subsection start */}
            {/* **** Sales Report Subsection End */}


            {/* ****SalesRep Subsection End  */}
            {/* ***Sales Section End */}

            {/* ***Operations Section Start */}
            {/* ****Job order subsection start  */}
            {/* <Route
              path="/manage-pending-job-schedule"
              element={
                <ProtectedRoute>
                  <ManagePendingJobSchedule />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/manage-job-orders"
              element={
                <ProtectedRoute>
                  <ManageJobOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-job-order"
              element={
                <ProtectedRoute>
                  <CreateJobOrder />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/schedule-job-order"
              element={
                <ProtectedRoute>
                  <ScheduleJobOrder />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/view-job-order/:id"
              element={
                <ProtectedRoute>
                  <ViewJobOrder />
                </ProtectedRoute>
              }
            />            
            <Route
              path="/edit-job-order/:id"
              element={
                <ProtectedRoute>
                  <EditJobOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-job-order/:id"
              element={
                <ProtectedRoute>
                  <DeleteJobOrder />
                </ProtectedRoute>
              }
            />
            {/* ****Job order subsection end  */}

            {/* ****Daily Forecast subsection start */}
            <Route
              path="/view-daily-forecast"
              element={
                <ProtectedRoute>
                  <ViewDailyForecast />
                </ProtectedRoute>
              }
            />
            {/* ****Daily Forecast subsection end */}

            {/* ****Technician Assignment subsection start */}

            <Route
              path="/assign-technicians"
              element={
                <ProtectedRoute>
                  <AssignTechnicians />
                </ProtectedRoute>
              }
            />

            <Route
              path="/batch-assign"
              element={
                <ProtectedRoute>
                  <BatchAssign />
                </ProtectedRoute>
              }
            />
            {/* ****Technician Assignment subsection end */}


            {/* ****Calendar subsection start  */}
            <Route
              path="/view-calendar"
              element={
                <ProtectedRoute>
                  <ViewCalendar />
                </ProtectedRoute>
              }
            />
            {/* ****Calendar subsection end  */}
            {/* ****Service Report Subsection start  */}
            <Route
              path="/create-service-report"
              element={
                <ProtectedRoute>
                  <CreateServiceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/submit-service-report/:id"
              element={
                <ProtectedRoute>
                  <SubmitServiceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manage-service-reports"
              element={
                <ProtectedRoute>
                  <ManageServiceReports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-service-report/:id"
              element={
                <ProtectedRoute>
                  <ViewServiceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-service-report/:id"
              element={
                <ProtectedRoute>
                  <EditServiceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/makati-gpc-form/:id"
              element={
                <ProtectedRoute>
                  <MakatiGpcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-makati-gpc-form/:id"
              element={
                <ProtectedRoute>
                  <ViewMakatiGpcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-makati-gpc-form/:id"
              element={
                <ProtectedRoute>
                  <EditMakatiGpcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-makati-gpc-form/:id"
              element={
                <ProtectedRoute>
                  <DeleteMakatiGpcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qc-form/:id"
              element={
                <ProtectedRoute>
                  <QcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-qc-form/:id"
              element={
                <ProtectedRoute>
                  <ViewQcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-qc-form/:id"
              element={
                <ProtectedRoute>
                  <EditQcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-qc-form/:id"
              element={
                <ProtectedRoute>
                  <DeleteQcForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/termite-control-form/:id"
              element={
                <ProtectedRoute>
                  <TermiteControlForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-termite-control-form/:id"
              element={
                <ProtectedRoute>
                  <ViewTermiteControlForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-termite-control-form/:id"
              element={
                <ProtectedRoute>
                  <EditTermiteControlForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transmittal-form/:id"
              element={
                <ProtectedRoute>
                  <TransmittalForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-transmittal-form/:id"
              element={
                <ProtectedRoute>
                  <EditTransmittalForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-transmittal-form/:id"
              element={
                <ProtectedRoute>
                  <ViewTransmittalForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-transmittal-form/:id"
              element={
                <ProtectedRoute>
                  <DeleteTransmittalForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delete-termite-control-form/:id"
              element={
                <ProtectedRoute>
                  <DeleteTermiteControlForm />
                </ProtectedRoute>
              }
            />
            {/* ****Termite Accomplishment Report Subsection start  */}
            <Route
              path="/create-accomplishment-reports"
              element={
                <ProtectedRoute>
                  <CreateAccomplishmentReport />
                </ProtectedRoute>
              }
            />
            {/* ****Termite Accomplishment Report Subsection end  */}
            {/* ****Service Report Subsection end  */}
            
            {/* ****Payroll Subsection start  */}
            <Route
              path="/payroll-reports"
              element={
                <ProtectedRoute path="/payroll-reports">
                  <PayrollReports />
                </ProtectedRoute>
              }
            />

            <Route
              path="/payroll-final-calculation"
              element={
                <ProtectedRoute path="/payroll-final-calculation">
                  <PayrollFinalCalculation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/technician-hours"
              element={
                <ProtectedRoute path="/technician-hours">
                  <TechnicianHours />
                </ProtectedRoute>
              }
            />

            <Route
              path="/technician-compensation"
              element={
                <ProtectedRoute path="/technician-compensation">
                  <TechnicianCompensation />
                </ProtectedRoute>
              }
            />
            {/* ****Payroll Subsection end  */}
            
            {/* ****Productivity Report Subsection start  */}
            <Route
              path="/view-productivity-report"
              element={
                <ProtectedRoute path="/view-productivity-report">
                  <ViewProductivityReport />
                </ProtectedRoute>
              }
            />
            {/* Operation Completion Report */}
            <Route
              path="/view-operation-completion-report"
              element={
                <ProtectedRoute path="/view-operation-completion-report">
                  <ViewOperationCompletionReport />
                </ProtectedRoute>
              }
            />
            {/* Open Job Orders Report */}
            <Route
              path="/view-open-job-orders-report"
              element={
                <ProtectedRoute path="/view-open-job-orders-report">
                  <ViewOpenJobOrdersReport />
                </ProtectedRoute>
              }
            />
            {/* ****Open Job Orders Report Subsection end  */}
            {/* ****Technicians Start */}
            <Route
              path="/manage-technicians"
              element={
                <ProtectedRoute path="/manage-technicians">
                  <ManageTechnicians />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-technician"
              element={
                <ProtectedRoute path="/add-technician">
                  <AddTechnician />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-technician"
              element={
                <ProtectedRoute path="/view-technician">
                  <ViewTechnician />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-technician"
              element={
                <ProtectedRoute path="/edit-technician">
                  <EditTechnician />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-competency-skills-matrix"
              element={
                <ProtectedRoute path="/view-competency-skills-matrix">
                  <ViewCompetencySkillsMatrix />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-professional-skills-matrix"
              element={
                <ProtectedRoute path="/view-professional-skills-matrix">
                  <ViewProfessionalSkillsMatrix />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-rest-day"
              element={
                <ProtectedRoute path="/view-rest-day">
                  <ViewRestDay />
                </ProtectedRoute>
              }
            />
            {/* Route Planner */}
            {/* <Route
              path="/route-planner"
              element={
                <ProtectedRoute path="/route-planner">
                  <RoutePlanner />
                </ProtectedRoute>
              }
            /> */}
            {/* Endorsement Form Section */}
            <Route
              path="/create-endorsement-form"
              element={
                <ProtectedRoute path="/create-endorsement-form">
                  <CreateEndorsementForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/submit-endorsement-form"
              element={
                <ProtectedRoute path="/submit-endorsement-form">
                  <SubmitEndorsementForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manage-endorsement-form"
              element={
                <ProtectedRoute path="/manage-endorsement-form">
                  <ManageEndorsementForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-endorsement-form"
              element={
                <ProtectedRoute path="/view-endorsement-form">
                  <ViewEndorsementForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-endorsement-form"
              element={
                <ProtectedRoute path="/edit-endorsement-form">
                  <EditEndorsementForm />
                </ProtectedRoute>
              }
            />
            {/* ****Endorsement Form End */}
            {/* ***Operations Section End */}
            {/* ***Finance Section Start*/}
            {/* ****Billing Records Start */}
            {/* <Route
              path="/manage-billing-records"
              element={
                <ProtectedRoute path="/manage-billing-records">
                  <ManageBillingRecords />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/create-billing-record"
              element={
                <ProtectedRoute path="/create-billing-record">
                  <CreateBillingRecord />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-billing-record/:id"
              element={
                <ProtectedRoute path="/view-billing-record/:id">
                  <ViewBillingRecord />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-billing-record/:id"
              element={
                <ProtectedRoute path="/edit-billing-record/:id">
                  <EditBillingRecord />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-billing-record-work-notes/:id"
              element={
                <ProtectedRoute path="/add-billing-record-work-notes/:id">
                  <AddBillingRecordWorkNotes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-aging-invoices"
              element={
                <ProtectedRoute path="/view-aging-invoices">
                  <ViewAgingInvoices />
                </ProtectedRoute>
              }
            /> */}
            {/* Clients Section */}
            <Route
              path="/manage-clients"
              element={
                <ProtectedRoute path="/manage-clients">
                  <ManageClients />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-client"
              element={
                <ProtectedRoute path="/create-client">
                  <CreateClient />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/view-client"
              element={
                <ProtectedRoute path="/view-client">
                  <ViewClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-client"
              element={
                <ProtectedRoute path="/edit-client">
                  <EditClient />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/job-order-history/:clientId"
              element={
                <ProtectedRoute path="/client-job-order-history/:clientId">
                  <ClientJobOrderHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-client-service-reports"
              element={
                <ProtectedRoute path="/view-client-service-reports">
                  <ViewClientServiceReports />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/view-client-service-history"
              element={
                <ProtectedRoute path="/view-client-service-history">
                  <ViewClientServiceHistory />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/view-client-billing-records"
              element={
                <ProtectedRoute path="/view-client-billing-records">
                  <ViewClientBillingRecords />
                </ProtectedRoute>
              }
            />
            <Route
              path="/view-client-billing-history"
              element={
                <ProtectedRoute path="/view-client-billing-history">
                  <ViewClientBillingHistory />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/send-job-order-reminder"
              element={
                <ProtectedRoute path="/send-job-order-reminder">
                  <SendJobOrderReminder />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/send-billing-reminder"
              element={
                <ProtectedRoute path="/send-billing-reminder">
                  <SendBillingReminder />
                </ProtectedRoute>
              }
            /> */}
            {/* Promotions Section */}
            <Route
              path="/send-promotions"
              element={
                <ProtectedRoute path="/send-promotions">
                  <SendPromotions />
                </ProtectedRoute>
              }
            />
            {/* ****Promotions End  */}
            <Route
              path="/list-email-exceptions"
              element={
                <ProtectedRoute path="/list-email-exceptions">
                  <ListEmailExceptions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manage-email-exception"
              element={
                <ProtectedRoute path="/manage-email-exception">
                  <ManageEmailException />
                </ProtectedRoute>
              }
            />
            {/* ***Client Retention End */}
            {/* ***Franchise Start*/}
            {/* ***Franchise End*/}
            {/* ***Admin Start  */}
            {/* ****Users Start  */}
            {/* <Route
              path="/manage-users"
              element={
                isAuthenticated ? <ManageUsers /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/add-user"
              element={isAuthenticated ? <AddUser /> : <Navigate to="/login" />}
            />
            <Route
              path="/view-user/:id"
              element={
                isAuthenticated ? <ViewUser /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/edit-user/:id"
              element={
                isAuthenticated ? <EditUser /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/delete-user/:id"
              element={
                isAuthenticated ? <DeleteUser /> : <Navigate to="/login" />
              }
            /> */}
            {/* ****Users End  */}
            {/* ***Admin End  */}
            <Route
              path="/login"
              element={<LoginUser onLogin={handleLogin} />}
            />
            <Route path="/logout" element={<LogoutUser />} />{" "}
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/not-authorized" element={<NotAuthorized />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<NotFound />} />
            {/* *** WITHOUT UI styling end ***   */}
            {/* *** Test Routes Start *** */}
            {/* <Route
              path="/list-lead-schedules"
              element={
                isAuthenticated ? (
                  <ListLeadSchedule />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/test-scheduler"
              element={
                isAuthenticated ? <TestScheduler /> : <Navigate to="/login" />
              } //testing scheduler - need to remove
            />
            <Route
              path="/test-scheduler"
              element={
                isAuthenticated ? <TestScheduler /> : <Navigate to="/login" />
              } //testing scheduler - need to remove
            />
            <Route
              path="/plot-schedule"
              element={
                isAuthenticated ? <PlotSchedule /> : <Navigate to="/login" />
              }
            />
            <Route
              path="/job-schedules"
              element={
                isAuthenticated ? <JobSchedules /> : <Navigate to="/login" />
              }
            /> */}
            {/* <Route
              path="/testing-list-leads"
              element={
                isAuthenticated ? <ManageLeads /> : <Navigate to="/login" />
              }
            /> */}
            {/* testing list-leads - need to remove */}
            {/* <Route
              path="/testing-job-orders"
              element={
                isAuthenticated ? <ListJobOrders /> : <Navigate to="/login" />
              }
            /> */}
            {/* testing job orders - need to remove */}
            {/* *** Test Routes End *** */}
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
